import styled from 'styled-components'
import TermsItem from './TermsItem'
import TermsList from './TermsList'
import MainButton from '../../atoms/MainButton'
import { terms } from '../../../data/terms'

const Container = styled.div`
  margin-top: 20px;
  hr {
    border: 1px solid ${(props) => props.theme.colors.neutral[300]};
    margin: 24px 0;
  }
`
const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px; /* Wrapper 최대 폭과 맞춤 */
  padding: 0 20px;   /* 좌우 여유 */
`

const TermsAgreeStep = ({agreedTerms, setAgreedTerms, onNext}) => {
  // 전체 항목 ID 리스트
  const allIds = terms.map(t => t.id)

  // 필수 항목 ID 리스트
  const requiredIds = terms.filter(t => t.required).map(t => t.id);

  // 약관 전체동의 선택
  const handleAllCheck = (checked) => {
    if (checked) setAgreedTerms(new Set(allIds));
    else setAgreedTerms(new Set());
  };

  // 하나의 아이템 선택
  const handleItemCheck = (id, checked) => {
    setAgreedTerms((prev) => {
      const updatedTerms = new Set(prev);
      if (checked) updatedTerms.add(id);
      else updatedTerms.delete(id);
      return updatedTerms;
    });
  };

  // 약관 전체동의 여부
  const isAllChecked = allIds.every((id) => agreedTerms.has(id));

  // 필수 사항 동의 여부
  const isRequiredChecked = requiredIds.every((id) => agreedTerms.has(id));

  // 다음 버튼 클릭 핸들러
  const handleNextClick = ()=> {
    sessionStorage.setItem('termsAgreed', 'true');
    onNext();
  }

  return (
    <Container>
      <TermsItem 
        label="약관 전체동의"
        checked={isAllChecked}
        onChange={(checked) => handleAllCheck(checked)}
        showArrow={false}/>
      <hr/>
      <TermsList 
        datas={terms}
        terms={agreedTerms}
        onItemCheck={handleItemCheck}/>
      <ButtonWrapper>
        <MainButton
          $variant="primary"
          title="다음"
          disabled={!isRequiredChecked}
          onClick={handleNextClick}/>
      </ButtonWrapper>
    </Container>
  )
}

export default TermsAgreeStep
